import { useActor } from '../../../../../components/hooks/useActor';
import { REDACTED_FIELD } from '../../../../../config/logrocket';
import { agencyIdentity } from './agencyIdentity';
import { useAgencyLogo } from './useAgencyLogo';
import classes from './agencyIdentity.module.css';

/** The signed-in agency's logo, name and location, so the broker experience's header says whose console this is. */
export function AgencyIdentityBlock() {
  const { account } = useActor();
  const logo = useAgencyLogo(account?.id);
  const identity = agencyIdentity(account ?? {});
  if (!identity) {
    return null;
  }
  return (
    <div className={classes.identity} data-qa="HEADER:agency">
      {logo && <img className={classes.logo} src={logo} alt="" />}
      <div className={classes.text}>
        <span className={`${classes.name} ${REDACTED_FIELD}`}>
          {identity.name}
        </span>
        {identity.location && (
          <span className={classes.location}>{identity.location}</span>
        )}
      </div>
    </div>
  );
}
